import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export const ImportEmailsButton = ({ onDone }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/employees/import-emails", fd);
      setResult(data);
      if (data.updated) onDone();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" onClick={() => ref.current?.click()} disabled={busy} className="active:scale-[0.98]" data-testid="import-emails-button">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileSpreadsheet className="mr-2 h-4 w-4" />} Importa email da CSV/Excel
      </Button>
      <input ref={ref} type="file" accept=".csv,.txt,.xlsx" className="hidden" onChange={upload} data-testid="import-emails-input" />
      <Dialog open={!!result} onOpenChange={(o) => !o && setResult(null)}>
        <DialogContent data-testid="import-emails-result">
          <DialogHeader>
            <DialogTitle>Import completato</DialogTitle>
            <DialogDescription>Colonne riconosciute: codice fiscale ed email (prima riga intestazione).</DialogDescription>
          </DialogHeader>
          {result && (
            <div className="space-y-2 text-sm">
              <p><b data-testid="import-updated-count">{result.updated}</b> email aggiornate · {result.unchanged} già corrette</p>
              {result.not_found.length > 0 && <p className="text-amber-800">Codici fiscali non in anagrafica ({result.not_found.length}): <span className="font-mono text-xs">{result.not_found.join(", ")}</span></p>}
              {result.invalid.length > 0 && <p className="text-rose-700">Email non valide ({result.invalid.length}): <span className="font-mono text-xs">{result.invalid.join(", ")}</span></p>}
            </div>
          )}
          <DialogFooter><Button onClick={() => setResult(null)} data-testid="import-emails-close">Chiudi</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
